import { createAction } from "@reduxjs/toolkit"

export const getChartUserTypeAsync = createAction(
   "chartUserType/getChartUserTypeDataAsync"
)

export const exportExcelChartUserTypeAsync = createAction<any>(
   "chartUserType/exportExcelChartUserTypeAsync"
)
